module.exports = __webpack_public_path__ + "img/new_bg.d260049.png";